// extracted by mini-css-extract-plugin
module.exports = {"tel":"ResultSms_tel__3BMqU","sms_text":"ResultSms_sms_text__1aZOc","button_send":"ResultSms_button_send__35iEx","error":"ResultSms_error__3Fwrz"};